﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { AuthService } from "@app/services/auth.service";
import { DialogService } from "@app/services/dialog.service";
import { eInputDialogType, IComment, InputDialogButton, IRootScope } from "@models";
import { icons } from "@tools";
import * as angular from "angular";

export interface ICommentsScope extends ng.IScope {
    objectId?: number;
    tableName?: string;
    api?: ICommentsApi;

    _comments?: IComment[];
    _delete: (item: IComment) => void;
    _cancel: () => void;
    _addComment: () => void;
    _edit: (item: IComment) => void;
    _model: any;
}

export interface ICommentsApi {
    refresh?: () => void;
}

@NgComponent({
    token: Token.KbComments,
    dependencies: [
        Token.$RootScope,
        Token.DialogService,
        Token.$Http,
        Token.AuthService,
    ]
})
export class KbComments extends Directive {
    constructor(
        private $rootScope: IRootScope,
        private dialogService: DialogService,
        private $http: ng.IHttpService,
        private authService: AuthService
    ) {
        super();

        this.replace = false;
        this.template = Dirs.component("kb-comments");
        this.restrict = "E";
        this.scope = {
            objectId: "=",
            tableName: "@",
            api: "=?"
        };

        this.link = (scope: ICommentsScope, element, atts: any) => {
            if (!angular.isDefined(scope.api)) {
                scope.api = {};
            }

            scope._comments = [];

            scope.api.refresh = () => {
                // get the comments for this object
                if (angular.isDefined(scope.objectId) && $rootScope.user.canViewComments) {
                    this.$http.get<IComment[]>("/api/comments", {
                        params: {
                            objectId: scope.objectId,
                            tableName: scope.tableName
                        }
                    } as ng.IRequestConfig).then(r => {
                        scope._comments = r.data ? r.data : [];
                    });
                }
            };
            scope.api.refresh();

            scope._delete = item => {
                scope._comments.remove(item);
                this.$http.delete("/api/comments/" + item.id);
            };

            scope._model = { text: "" };

            scope._cancel = () => {
                scope._model.text = "";
            };

            scope._addComment = () => {

                let newComment: IComment = {
                    idUser: $rootScope.user.id,
                    tableName: scope.tableName,
                    body: scope._model.text,
                    createdByName: $rootScope.user.firstName + " " + $rootScope.user.lastName,
                    createdByImagePath: $rootScope.user.imagePath
                };

                this.$http.post<IComment>("/api/comments/" + scope.objectId, newComment).then(r => {
                    scope._comments.push(r.data);
                    scope._model.text = "";
                });
            };

            scope._edit = (item: IComment) => {
                dialogService.input({
                    msg: "Comment Edit",
                    inputType: eInputDialogType.textArea,
                    value: item.body,
                    buttons: [
                        new InputDialogButton(loc.ok, icons.success, args => {
                            item.body = args.value;
                            this.$http.put("/api/comments/" + item.id, item).then(r => {

                            });
                        }),
                        new InputDialogButton(loc.cancel, icons.cancel, args => {

                        })
                    ]
                });
            };
        };
    }

}
